import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  useUpdateFoodItemDetailsMutation,
  useUploadPhotoMutation,
} from "../slices/FoodItemSilce";
import { toast } from "react-toastify";
import { Button, Col, Form, Row } from "react-bootstrap";
import FieldWarning from "../components/FieldWarning";
import { useLocation, useNavigate } from "react-router-dom";
import imageCompression from "browser-image-compression";

const EditFoodItemDetails = () => {
  const { userInfo } = useSelector((state) => state.auth);
  const navigate = useNavigate();

  const { state } = useLocation();
  const { foodItem, refetch } = state || {};

  const [itemName, setItemName] = useState(foodItem?.itemName);
  const [localName, setLocalName] = useState(foodItem?.localName);
  const [itemCategory, setItemCategory] = useState(foodItem?.itemCategory);
  const [itemQuantity, setItemQuantity] = useState(foodItem?.itemQuantity);
  const [itemOriginalPrice, setItemOriginalPrice] = useState(
    foodItem?.itemOriginalPrice
  );
  const [itemOfferPrice, setItemOfferPrice] = useState(
    foodItem?.itemOfferPrice
  );
  const [discountPercent, setDiscountPercent] = useState(
    foodItem?.discountPercent
  );
  const [discountAmount, setDiscountAmount] = useState(
    foodItem?.discountAmount
  );
  const [gstTax, setGstTax] = useState(foodItem?.gstTax);
  const [currentlySelling, setCurrentlySelling] = useState(
    foodItem?.currentlySelling
  );
  const [addedBy, setAddedBy] = useState(foodItem?.addedBy);

  const [itemNamePresent, setItemNamePresent] = useState(false);
  const [localNamePresent, setLocalNamePresent] = useState(false);
  const [itemCategoryPresent, setItemCategoryPresent] = useState(false);
  const [itemQuantityPresent, setItemQuantityPresent] = useState(false);
  const [itemOriginalPricePresent, setItemOriginalPricePresent] =
    useState(false);
  const [itemOfferPricePresent, setItemOfferPricePresent] = useState(false);
  const [discountPercentPresent, setDiscountPercentPresent] = useState(false);
  const [discountAmountPresent, setDiscountAmountPresent] = useState(false);
  const [currentlySellingPresent, setCurrentlySellingPresent] = useState(false);
  const [gstTaxPresent, setGstTaxPresent] = useState(false);
  const [addedByPresent, setAddedByPresent] = useState(false);
  const [file, setFile] = useState(null);
  const [fileSizeError, setFileSizeError] = useState(false);
  const [fileInvalidError, setFileInvalidError] = useState(false);

  const [updateFoodItem, { isLoading }] = useUpdateFoodItemDetailsMutation();
  const [uploadPhoto, { isLoading: isPhotoUploading }] =
    useUploadPhotoMutation();

  const curSale = ["Yes", "No"];

  useEffect(() => {
    if (itemName?.length > 0) {
      setItemNamePresent(false);
    }

    // if (localName?.length > 0) {
    //   setLocalNamePresent(false);
    // }

    if (itemCategory?.length > 0) {
      setItemCategoryPresent(false);
    }

    if (itemQuantity > 0) {
      setItemQuantityPresent(false);
    }

    if (itemOriginalPrice > 0) {
      setItemOriginalPricePresent(false);
    }

    if (itemOfferPrice > 0) {
      setItemOfferPricePresent(false);
    }

    if (discountPercent >= 0) {
      setDiscountPercentPresent(false);
    }

    if (discountAmount >= 0) {
      setDiscountAmountPresent(false);
    }

    if (gstTax >= 0) {
      setGstTaxPresent(false);
    }

    if (addedBy?.length > 0) {
      setAddedByPresent(false);
    }
  }, [
    itemName,
    localName,
    itemCategory,
    itemQuantity,
    itemOriginalPrice,
    itemOfferPrice,
    discountPercent,
    discountAmount,
    gstTax,
    addedBy,
  ]);

  const verifyInputFields = () => {
    let fieldValidationSuccess = true;

    if (!itemName || itemName.length < 1 || itemName.length > 100) {
      setItemNamePresent(true);
      fieldValidationSuccess = false;
    }

    // if (!localName || localName.length < 1 || localName.length > 100) {
    //   setLocalNamePresent(true);
    //   fieldValidationSuccess = false;
    // }

    if (!itemCategory || itemCategory.length < 1) {
      setItemCategoryPresent(true);
      fieldValidationSuccess = false;
    }

    if (!itemQuantity || itemQuantity < 1) {
      setItemQuantityPresent(true);
      fieldValidationSuccess = false;
    }

    if (!itemOriginalPrice || itemOriginalPrice < 1) {
      setItemOriginalPricePresent(true);
      fieldValidationSuccess = false;
    }

    if (!itemOfferPrice || itemOfferPrice < 1) {
      setItemOfferPricePresent(true);
      fieldValidationSuccess = false;
    }

    if (discountPercent < 0) {
      setDiscountPercentPresent(true);
      fieldValidationSuccess = false;
    }

    if (discountAmount < 0) {
      setDiscountAmountPresent(true);
      fieldValidationSuccess = false;
    }

    if (gstTax < 0) {
      setGstTaxPresent(true);
      fieldValidationSuccess = false;
    }

    if (!addedBy || addedBy.length < 1) {
      setAddedByPresent(true);
      fieldValidationSuccess = false;
    }

    if (!fieldValidationSuccess) {
      toast.error(
        "Some of the fields have invalid inputs. Please provide valid details."
      );
    }

    return fieldValidationSuccess;
  };

  const handleSubmit = async () => {
    if (verifyInputFields()) {
      try {
        const data = {
          _id: foodItem?._id,

          itemName: itemName,
          localName: localName,
          itemCategory: itemCategory,
          itemQuantity: itemQuantity,
          itemOriginalPrice: itemOriginalPrice,
          itemOfferPrice: itemOfferPrice,
          discountPercent: discountPercent,
          discountAmount: discountAmount,
          currentlySelling: currentlySelling,
          gstTax: gstTax,
          addedBy: addedBy,
          token: userInfo.token,
        };
        const resData = await updateFoodItem(data).unwrap();
        if (resData && file) {
          let formData = new FormData();
          formData.append("image", file);
          formData.append("imageKey", `${resData._id}`); // or use foodItem._id if needed

          await uploadPhoto({
            token: userInfo.token,
            payload: formData,
          }).unwrap();
        }

        toast.success("Details updated Successfully");
        navigate(`/foodItem/${foodItem?._id}`, { state: { showEdit: false } });
      } catch (e) {
        toast.error("something went wrong");
      }
    }
  };

  const handleCancelButton = () => {
    navigate(`/foodItem/${foodItem?._id}`);
  };

  const compressImage = async (selectedImage) => {
    const file = selectedImage;
    if (file) {
      try {
        const options = {
          maxSizeMB: 1,
          maxWidthOrHeight: 280,
          useWebWorker: true,
          initialQuality: 1,
        };

        console.log("Un-Compressed file:", file);
        const compressedFile = await imageCompression(file, options);

        const secondOptions = {
          maxSizeMB: 1,
          useWebWorker: true,
          initialQuality: 0.9,
        };

        const secondCompressedFile = await imageCompression(
          compressedFile,
          secondOptions
        );
        console.log("Second Compressed file:", secondCompressedFile);
        setFile(secondCompressedFile);
      } catch (error) {
        console.error("Error processing image:", error);
      }
    }
  };
  const handleFileChange = async (e) => {
    const selectedFile = e?.target?.files[0];
    const dotIndex = selectedFile?.name?.lastIndexOf(".");
    const fileExtension = selectedFile?.name?.slice(dotIndex + 1).toLowerCase();
    let errorPresent = false;
    if (
      !(
        fileExtension === "jpeg" ||
        fileExtension === "jpg" ||
        fileExtension === "png" ||
        fileExtension === "tiff" ||
        fileExtension === "svg" ||
        fileExtension === "jfif"
      )
    ) {
      errorPresent = true;
      setFileInvalidError(true);
      setFile(null);
    } else if (selectedFile?.size / 1000 > 5120) {
      setFileSizeError(true);
      setFile(null);
    } else if (!errorPresent && selectedFile?.size / 1000 <= 5120) {
      setFileSizeError(false);
      setFileInvalidError(false);
      await compressImage(selectedFile);
    }
  };

  return (
    <>
      <h5>Edit FoodDetails</h5>
      <Row>
        <Col sm={3} style={{ marginRight: "1rem" }}>
          <Form.Group>
            <Form.Label>Item Name</Form.Label>
            <Form.Control
              type="text"
              value={itemName}
              onChange={(e) => setItemName(e.target.value)}
            />
            {itemNamePresent && (
              <FieldWarning text="Item name cannot be empty and must be between 1 to 100 characters" />
            )}
          </Form.Group>
        </Col>

        <Col sm={3} style={{ marginRight: "1rem" }}>
          <Form.Group>
            <Form.Label>Local Name</Form.Label>
            <Form.Control
              type="text"
              value={localName}
              onChange={(e) => setLocalName(e.target.value)}
            />
            {/* {localNamePresent && (
              <FieldWarning text="Local name cannot be empty and must be between 1 to 100 characters" />
            )} */}
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col sm={3} style={{ marginRight: "1rem" }}>
          <Form.Group>
            <Form.Label>Item Category</Form.Label>
            <Form.Control
              type="text"
              value={itemCategory}
              onChange={(e) => setItemCategory(e.target.value)}
            />
            {itemCategoryPresent && (
              <FieldWarning text="Item category cannot be empty" />
            )}
          </Form.Group>
        </Col>

        <Col sm={3} style={{ marginRight: "1rem" }}>
          <Form.Group>
            <Form.Label>Quantity</Form.Label>
            <Form.Control
              type="number"
              value={itemQuantity}
              onChange={(e) => setItemQuantity(e.target.value)}
            />
            {itemQuantityPresent && (
              <FieldWarning text="Quantity must be greater than 0" />
            )}
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col sm={3} style={{ marginRight: "1rem" }}>
          <Form.Group>
            <Form.Label>Original Price</Form.Label>
            <Form.Control
              type="number"
              value={itemOriginalPrice}
              onChange={(e) => setItemOriginalPrice(e.target.value)}
            />
            {itemOriginalPricePresent && (
              <FieldWarning text="Original price must be greater than 0" />
            )}
          </Form.Group>
        </Col>

        <Col sm={3} style={{ marginRight: "1rem" }}>
          <Form.Group>
            <Form.Label>Offer Price</Form.Label>
            <Form.Control
              type="number"
              value={itemOfferPrice}
              onChange={(e) => setItemOfferPrice(e.target.value)}
            />
            {itemOfferPricePresent && (
              <FieldWarning text="Offer price must be greater than 0" />
            )}
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col sm={3} style={{ marginRight: "1rem" }}>
          <Form.Group>
            <Form.Label>Discount Percent</Form.Label>
            <Form.Control
              type="number"
              value={discountPercent}
              onChange={(e) => setDiscountPercent(e.target.value)}
            />
            {discountPercentPresent && (
              <FieldWarning text="Discount percent cannot be negative" />
            )}
          </Form.Group>
        </Col>

        <Col sm={3} style={{ marginRight: "1rem" }}>
          <Form.Group>
            <Form.Label>Discount Amount</Form.Label>
            <Form.Control
              type="number"
              value={discountAmount}
              onChange={(e) => setDiscountAmount(e.target.value)}
            />
            {discountAmountPresent && (
              <FieldWarning text="Discount amount cannot be negative" />
            )}
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col sm={3} style={{ marginRight: "1rem" }}>
          <Form.Group>
            <Form.Label>GST Tax</Form.Label>
            <Form.Control
              type="number"
              value={gstTax}
              onChange={(e) => setGstTax(e.target.value)}
            />
            {gstTaxPresent && (
              <FieldWarning text="GST tax cannot be negative" />
            )}
          </Form.Group>
        </Col>

        <Col sm={3} style={{ marginRight: "1rem" }}>
          <Form.Group>
            <Form.Label>Added By</Form.Label>
            <Form.Control
              type="text"
              value={addedBy}
              onChange={(e) => setAddedBy(e.target.value)}
            />
            {addedByPresent && (
              <FieldWarning text="Added By field cannot be empty" />
            )}
          </Form.Group>
        </Col>
      </Row>
      <br />
      <Row>
        <Form.Group as={Row}>
          <Form.Label column="true" sm="3">
            {" "}
            Currently Selling ?
          </Form.Label>
          <Col sm="6">
            <div className="horizontal-radio-group">
              {curSale?.map((option) => (
                <Form.Check
                  key={option}
                  type="radio"
                  label={option}
                  name="platRadio"
                  id={`platRadio-${option}`}
                  value={option}
                  checked={currentlySelling === (option === "Yes")}
                  onChange={(e) =>
                    setCurrentlySelling(e.target.value === "Yes")
                  }
                />
              ))}
              {currentlySellingPresent ? (
                <FieldWarning text="Please select one option" />
              ) : (
                ""
              )}
            </div>
          </Col>
        </Form.Group>
        <Form.Group as={Row} className="my-2" controlId="photo">
          <Form.Label column="true" sm="4">
            upload image :
          </Form.Label>
          <Col sm="6">
            <input
              type="file"
              onChange={handleFileChange}
              style={{ color: "white" }}
            />
            {fileSizeError && (
              <label style={{ color: "red" }}>
                Image size should be less than 5 MB, Please select different
                Image.
              </label>
            )}
            {fileInvalidError && (
              <label style={{ color: "red" }}>
                Only jpeg, jpg, png, tiff and svg formats are supported
              </label>
            )}
          </Col>
        </Form.Group>
      </Row>
      <br />

      <Row className="justify-content-center mt-4">
        <Col sm="auto">
          <Button variant="primary" onClick={handleSubmit}>
            Submit
          </Button>
        </Col>
        <Col sm="auto">
          <Button variant="secondary" onClick={handleCancelButton}>
            Cancel
          </Button>
        </Col>
      </Row>
    </>
  );
};

export default EditFoodItemDetails;
